var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Expendable extends Component {
    constructor() {
        super('Expendable', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('body').on('click', '.btn-view-more', (event, button) => {
                const expendableElement = button.prev();
                if (button.hasClass('active')) {
                    expendableElement.css('max-height', expendableElement.find('.expendable-content').height());
                    setTimeout(() => {
                        button.removeClass('active');
                        expendableElement.css('max-height', this.computeDefautlLineHeight(expendableElement));
                    }, 40);
                }
                else {
                    button.addClass('active');
                    expendableElement.css('max-height', expendableElement.find('.expendable-content').height());
                }
            });
            $(window).on('resize', this.update);
            this.update();
            this.success();
        });
    }
    computeDefautlLineHeight(element) {
        let maxHeight = 0;
        if (element.hasClass('expendable-video')) {
            const videoElement = element.find('.video').eq(parseInt(element.data('maxItems')) - 1);
            maxHeight = videoElement.position(element).y + videoElement.height();
        }
        else {
            maxHeight = parseFloat(element.css('line-height')) * parseInt(element.data('maxLines'));
        }
        return maxHeight;
    }
    update() {
        $('.expendable').each((element) => {
            const maxHeight = this.computeDefautlLineHeight(element);
            element.parents('.collapse').addClass('show');
            element.css('max-height', maxHeight);
            if (maxHeight < element.find('.expendable-content').height()) {
                const viewMoreButton = $.parseHTML('<a class="btn-view-more icon-plus"></a>');
                element.parent().append(viewMoreButton);
            }
            else {
                element.parent().find('.btn-view-more').remove();
            }
            element.parents('.collapse').removeClass('show');
        });
    }
}
